module.exports = __webpack_public_path__ + "static/media/about-illustration.660cb403.svg";